import { forwardRef } from "react";
import Box from "@ui-kit/layout/Box/Box.web";
import type { DropdownSharedProps } from "./Dropdown.props";

export type DropdownProps = DropdownSharedProps & {
  // Add any web specific props here
};

const getDropdownPadding = (variant: DropdownProps["variant"]): string => {
  let padding = "20px 10px";
  if (variant === "secondary") {
    padding = "15px 0px";
  } else if (variant === "outline") {
    padding = "20px";
  }

  return padding;
};

const Dropdown = forwardRef<HTMLDivElement, DropdownProps>(function Dropdown(
  props,
  ref
) {
  const { variant = "primary", children, maxHeight, ...rest } = props;

  return (
    <Box
      {...rest}
      ref={ref}
      className="dropdown"
      position="absolute"
      backgroundColor="bg"
      zIndex="modal"
      mt="xs"
      borderRadius="lg"
      w="100%"
      maxHeight={maxHeight ?? "310px"}
      overflow="auto"
      boxShadow="0px 4px 10px rgba(0, 0, 0, 0.2)"
      css={{
        "&:focus": {
          outline: "0px !important",
        },
        "& ul": {
          padding: `${getDropdownPadding(variant)}`,
          height: "auto",
        },
        "& li": {
          borderRadius: `${variant === "primary" ? "50px" : "inherit"}`,
          padding: { base: "8px 13px 8px 13px", sm: "0px 5px" },
          minHeight: { base: "40px", sm: "35px" },
          marginBottom: { base: "0px", sm: "2px" },
          bg: "bg",
          color: "fg",
          cursor: "pointer",
          pointerEvents: "auto",
        },
        "& li:hover": {
          backgroundColor: "primary.bg.subtle",
          color: "fg",
        },
      }}
    >
      {children}
    </Box>
  );
});

export default Dropdown;
